import utilsCommon from "./common";

const utilsClient = {
  /** 세션 아웃시, 세션 재호출 */
  goMain: () => {
    if (utilsCommon.isClientLogin("MAC")) {
      (window as any)?.webkit?.messageHandlers.goMain.postMessage("");
    } else if (utilsCommon.isClientLogin("WINDOWS")) {
      window.chrome.webview.hostObjects.client.goMain();
    }
  },
  setClientHeight: (size: number | string) => {
    if (utilsCommon.isClientLogin("MAC")) {
      (window as any)?.webkit?.messageHandlers.setHeight.postMessage(size);
    } else if (utilsCommon.isClientLogin("WINDOWS")) {
      window?.chrome?.webview?.hostObjects.client.setHeight(size);
    }
  },
  setClientWidth: (size: number | string) => {
    if (utilsCommon.isClientLogin("MAC")) {
      (window as any)?.webkit?.messageHandlers.setWidth.postMessage(size);
    } else if (utilsCommon.isClientLogin("WINDOWS")) {
      window?.chrome?.webview?.hostObjects.client.setWidth(size);
    }
  },
  closeClient: () => {
    if (utilsCommon.isClientLogin("MAC")) {
      (window as any)?.webkit?.messageHandlers.closeWindow.postMessage("");
    } else if (utilsCommon.isClientLogin("WINDOWS")) {
      window?.chrome?.webview?.hostObjects.client.closeWindow("");
    }
  },
  reportErrorToClient: (error: { message: string; name: string }) => {
    if (utilsCommon.isClientLogin("MAC")) {
      (window as any)?.webkit?.messageHandlers.failUploadComplete.postMessage({
        Message: error.message,
        Code: error.name,
      });
    } else if (utilsCommon.isClientLogin("WINDOWS")) {
      window?.chrome?.webview?.postMessage({
        MessageKey: "failUploadComplete",
        Message: error.message,
        Code: error.name,
      });
    }
  },
  uploadComplete: (completeItem: {
    workgroupId: string;
    workgroupName?: string;
    uploadedDocs: { syncId: string; fileId: string }[];
    workgroupType?: string;
  }) => {
    if (utilsCommon.isClientLogin("MAC")) {
      (window as any)?.webkit?.messageHandlers.uploadComplete.postMessage(
        JSON.stringify(completeItem)
      );
    } else if (utilsCommon.isClientLogin("WINDOWS")) {
      window?.chrome?.webview?.hostObjects.client.uploadComplete(
        JSON.stringify(completeItem)
      );
    }
  },
  copyLink: (link: string) => {
    if (utilsCommon.isClientLogin("MAC")) {
      (window as any)?.webkit?.messageHandlers.copyLink.postMessage(link);
    } else if (utilsCommon.isClientLogin("WINDOWS")) {
      window?.chrome?.webview?.hostObjects.client.copyLink(link);
    }
  },
  goToComprssedHistory: (workgroupId: string) => {
    if (utilsCommon.isClientLogin("MAC")) {
      (
        window as any
      )?.webkit?.messageHandlers?.goWebWorkgroupHistory.postMessage(
        workgroupId
      );
    } else if (utilsCommon.isClientLogin("WINDOWS")) {
      window?.chrome?.webview?.hostObjects.client.goWebWorkgroupHistory(
        workgroupId
      );
    }
  },
};
export default utilsClient;
